/** Amazon Redshift's logo URL. Kept separate from `redshift-ai`'s
 * registration so the MCP server spec can use it without registering the
 * integration. */
export const RedshiftAiIconUrl =
  "https://upload.wikimedia.org/wikipedia/commons/7/73/Amazon-Redshift-Logo.svg";
